var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFooterLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 3.6665C19.5304 3.6665 20.0391 3.87722 20.4142 4.25229C20.7893 4.62736 21 5.13607 21 5.6665V19.6665C21 20.1969 20.7893 20.7056 20.4142 21.0807C20.0391 21.4558 19.5304 21.6665 19 21.6665H5C4.46957 21.6665 3.96086 21.4558 3.58579 21.0807C3.21071 20.7056 3 20.1969 3 19.6665V5.6665C3 5.13607 3.21071 4.62736 3.58579 4.25229C3.96086 3.87722 4.46957 3.6665 5 3.6665H19ZM18.5 19.1665V13.8665C18.5 13.0019 18.1565 12.1727 17.5452 11.5613C16.9338 10.95 16.1046 10.6065 15.24 10.6065C14.39 10.6065 13.4 11.1265 12.92 11.9065V10.7965H10.13V19.1665H12.92V14.2365C12.92 13.4665 13.54 12.8365 14.31 12.8365C14.6813 12.8365 15.0374 12.984 15.2999 13.2466C15.5625 13.5091 15.71 13.8652 15.71 14.2365V19.1665H18.5ZM6.88 9.2265C7.32556 9.2265 7.75288 9.0495 8.06794 8.73444C8.383 8.41938 8.56 7.99207 8.56 7.5465C8.56 6.6165 7.81 5.8565 6.88 5.8565C6.43178 5.8565 6.00193 6.03456 5.68499 6.35149C5.36805 6.66843 5.19 7.09829 5.19 7.5465C5.19 8.4765 5.95 9.2265 6.88 9.2265ZM8.27 19.1665V10.7965H5.5V19.1665H8.27Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterLinkedin);
export default __webpack_public_path__ + "static/media/footer_linkedin.259a581fb21afa94d2d49fca1456c48c.svg";
export { ForwardRef as ReactComponent };